function initFeaturedProducts() {
  const featuredProducts = document.querySelector('.section-featured-products');
  if(!featuredProducts) return;

  const featuredProductsSlider = new Swiper('.featured-products-slider', {
    slidesPerView: 1.1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    },
    navigation: {
      prevEl: '.featured-products-slider__button.prev',
      nextEl: '.featured-products-slider__button.next',
    },
    pagination: {
      el: '.featured-products-slider__pagination',
      type: 'bullets',
      clickable: true
    }
  });
}

window.addEventListener('load', initFeaturedProducts);